// Helpers for Indonesian Rupiah price inputs.
//
// parseDigits: return the digits of `input`, capped at MAX_DIGITS.
//   - Anything after the first "," is dropped (Indonesian decimal separator);
//     Rupiah has no cents in practice, so pasted "Rp 1.500,50" becomes "1500".
//   - "." is treated as a thousands separator and stripped by the digit filter,
//     so "1.500.000" -> "1500000".
//   - Because the field uses inputMode="numeric" there is no "." on the mobile
//     keypad; the "." handling is purely for paste from external sources.
//
// formatIDR: render a number/digit-string with id-ID thousand separators
//   (e.g. 1500000 -> "1.500.000"). Empty / nullish / NaN / 0 -> "".
//   (0 is not a valid price and existing form validation rejects it.)

const MAX_DIGITS = 12;

export function parseDigits(input) {
  if (input === null || input === undefined) return "";
  const beforeDecimal = String(input).split(",")[0];
  const digits = beforeDecimal.replace(/\D/g, "");
  return digits.slice(0, MAX_DIGITS);
}

export function formatIDR(value) {
  if (value === null || value === undefined || value === "") return "";
  const digits = typeof value === "number" ? String(value) : parseDigits(value);
  if (digits === "") return "";
  const n = Number(digits);
  if (!Number.isFinite(n) || n === 0) return "";
  return new Intl.NumberFormat("id-ID").format(n);
}
